/** Paints a 2px `--focus-border` edge over the box's outer 2px, so focus never resizes or moves content. */
export const FOCUS_BORDER_CLASS =
  "focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-[var(--focus-border)]";

export const FOCUS_RING_INSET_CLASS =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--focus-border)]";
